import { Suspense } from 'react'
import { Route, Routes } from 'react-router-dom'
import { PageLoader } from '@forwardflow/ui/PageLoader'
import {
   CampaignFlowEntry,
   CampaignFlowLive,
   CampaignFlowPage,
   CampaignWorkspace,
} from '@forwardflow/features/campaign-flow'
import { CampaignReadinessGate } from '@forwardflow/features/onboarding-v2'
import { CampaignHome } from './components/CampaignHome'
import { CampaignLeadSourceList } from './components/CampaignLeadSourceList'
import { ActivateCampaignPage } from './components/activate-campaign/ActivateCampaignPage'
import { PhoneNumberPage } from './components/phone-number/PhoneNumberPage'
import { SetAssistants } from './components/assistants/SetAssistants'
import { AgentAssignmentConfig } from './components/agent-assignment/AgentAssignmentConfig'
import { ConfigCampaignPage } from './components/activate-campaign/ConfigCampaignPage'

/**
 * `/campaign` is the Campaigns overview. Creating and editing a campaign is
 * the guided flow (`flow/new`, `flow/:id/edit`); a campaign's own page is
 * `flow/:id`. A new account still being set up sees the setup tracker in
 * place of the overview and the new-campaign flow (`CampaignReadinessGate`).
 * The sidebar workspace stays reachable at `v2/new` and `v2/:id`,
 * and the screens made before campaign v2 keep their addresses.
 */
export const CampaignRoutes = () => {
   return (
      <Suspense fallback={<PageLoader />}>
         <Routes>
            <Route
               index
               element={
                  <CampaignReadinessGate>
                     <CampaignFlowEntry />
                  </CampaignReadinessGate>
               }
            />
            <Route element={<CampaignHome />}>
               <Route path=":title" element={<CampaignLeadSourceList />} />
            </Route>
            {/* The sidebar workspace (campaign v2 editor). */}
            <Route path="v2/new" element={<CampaignWorkspace />} />
            <Route path="v2/:id" element={<CampaignWorkspace />} />
            {/* Guided campaign creation: overview, editor, live campaign. */}
            <Route
               path="flow"
               element={
                  <CampaignReadinessGate>
                     <CampaignFlowEntry />
                  </CampaignReadinessGate>
               }
            />
            <Route
               path="flow/new"
               element={
                  <CampaignReadinessGate>
                     <CampaignFlowPage />
                  </CampaignReadinessGate>
               }
            />
            <Route path="flow/:id/edit" element={<CampaignFlowLive />} />
            <Route path="flow/:id" element={<CampaignFlowLive />} />
            <Route path=":title/activate" element={<ActivateCampaignPage />} />
            <Route path=":title" element={<ConfigCampaignPage />}>
               <Route path="phone-number" element={<PhoneNumberPage />} />
               <Route path="assistants" element={<SetAssistants />} />
               <Route
                  path="agent-assignment"
                  element={<AgentAssignmentConfig />}
               />
            </Route>
         </Routes>
      </Suspense>
   )
}
